import {
  FaBullseye,
  FaEye,
  FaCheckCircle,
  FaBuilding,
  FaQuoteLeft,
  FaStar,
  FaGlobe,
  FaLinkedin,
  FaEnvelope
} from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function About() {
  return (
    <div className="bg-slate-50 text-slate-800 antialiased font-sans">
      {/* HERO SECTION */}
      <section className="relative bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:40px_40px]"></div>
        <div className="max-w-7xl mx-auto px-6 py-16 lg:py-20 relative z-10">
          <div className="grid lg:grid-cols-2 gap-6 items-center">
            <div>
              <span className="inline-block bg-[#C8A96B]/20 text-[#C8A96B] px-4 py-2 rounded-full uppercase tracking-[3px] text-xs font-semibold">
                Engineering Excellence
              </span>
              <h1 className="text-5xl lg:text-5xl lg:text-5xl lg:text-5xl lg:text-5xl lg:text-5xl lg:text-5xl lg:text-6xl font-black text-white leading-tight mt-6">
                Building Tomorrow<br />
                <span className="text-[#C8A96B]">With Precision</span>
              </h1>
              <p className="text-slate-300 text-lg leading-relaxed mt-8 max-w-xl">
                Vamco Architectural Prospective Drawings Services LLC, alongside our trusted associates Falcosys Infotech Ltd and Astra Engineering Consultants, operates as a premier multi-disciplinary engineering .
              </p>
              <div className="flex flex-wrap gap-5 mt-8">
                <button className="bg-[#C8A96B] hover:bg-[#b99655] text-slate-900 px-8 py-4 rounded-xl font-bold transition">
                  Get Proposal
                </button>
                <button className="border border-white/20 hover:border-[#C8A96B] hover:text-[#C8A96B] text-white px-8 py-4 rounded-xl font-semibold transition">
                  Explore Services
                </button>
              </div>
            </div>
            <div>
              <Swiper
                modules={[Autoplay, Pagination]}
                autoplay={{ delay: 3500, disableOnInteraction: false }}
                pagination={{ clickable: true }}
                loop={true}
                className="rounded-3xl overflow-hidden shadow-2xl"
              >
                <SwiperSlide>
                  <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd" className="h-[420px] lg:h-[480px] w-full object-cover" alt="Construction site detailing" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5" cclassName="h-[420px] lg:h-[480px] w-full object-cover" alt="Civil engineering management" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab" className="h-[420px] lg:h-[480px] w-full object-cover" alt="Modern structural engineering" />
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT COMPANY SECTION */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab" className="rounded-3xl shadow-2xl w-full object-cover h-[380px]" alt="Corporate Architecture Overview" />
            </div>
            <div>
              <p className="uppercase tracking-[5px] text-[#C8A96B] font-semibold">ABOUT VAMCO & ASSOCIATES</p>
              <h2 className="text-5xl font-bold text-slate-900 mt-5">Engineering Beyond Drawings</h2>
              <div className="w-24 h-1 bg-[#C8A96B] my-8"></div>
              <p className="text-slate-600 leading-8">
                Starting with the establishment of Falcosys, we have built a long-standing foundation of engineering excellence. Today, Vamco Architectural Prospective Drawings Services LLC, together with our trusted associates Falcosys Infotech Ltd and Astra Engineering Consultants, forms a premier multi-disciplinary engineering . By combining our specialized expertise, we deliver high-quality engineering solutions that support efficient, accurate, and cost-effective project execution.
              </p>
              <p className="text-slate-600 leading-8 mt-6">
                We are a specialized engineering services firm providing high-precision structural rebar detailing, accurate Bar Bending Schedules (BBS), generating code-compliant shop drawings and optimized Bar Bending Schedules to minimize steel scrap and speed up site placement, and comprehensive MEP BIM coordination. Our approach bridges the gap between design and construction, delivering fully coordinated, clash-free models that ensure seamless structural integrity and flawless building performance.
              </p>
              <div className="grid grid-cols-2 gap-5 mt-8">
                <div className="flex items-center gap-3 font-medium text-slate-800"><FaCheckCircle className="text-[#C8A96B]" /> Code-Compliant Shop Drawings</div>
                <div className="flex items-center gap-3 font-medium text-slate-800"><FaCheckCircle className="text-[#C8A96B]" /> 100+ Projects Completed</div>
                <div className="flex items-center gap-3 font-medium text-slate-800"><FaCheckCircle className="text-[#C8A96B]" /> GCC Coverage</div>
                <div className="flex items-center gap-3 font-medium text-slate-800"><FaCheckCircle className="text-[#C8A96B]" /> Global Project Delivery</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MISSION, VISION & STATS */}
      <section className="bg-slate-50 py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="uppercase tracking-[5px] text-[#C8A96B] font-semibold">Our Foundation</p>
            <h2 className="text-5xl font-bold text-slate-900 mt-4">Driven by Innovation, Powered by Precision</h2>
          </div>
          <div className="grid lg:grid-cols-2 gap-6">
            <div className="bg-white rounded-3xl p-6 shadow-lg border border-slate-200 hover:-translate-y-2 transition duration-300">
              <div className="w-16 h-16 rounded-2xl bg-[#C8A96B]/10 flex items-center justify-center mb-8">
                <FaBullseye className="text-3xl text-[#C8A96B]" />
              </div>
              <h3 className="text-3xl font-bold text-slate-900 mb-6">Our Mission</h3>
              <p className="text-slate-600 leading-8">
                To deliver clear, code-compliant fabrication and construction blueprints, precise material optimization, and fully integrated system workflows that help clients enhance constructability, improve structural integrity, reduce rework, and achieve flawless building performance across all infrastructure developments.
              </p>
            </div>
            <div className="bg-white rounded-3xl p-6 shadow-lg border border-slate-200 hover:-translate-y-2 transition duration-300">
              <div className="w-16 h-16 rounded-2xl bg-[#C8A96B]/10 flex items-center justify-center mb-8">
                <FaEye className="text-3xl text-[#C8A96B]" />
              </div>
              <h3 className="text-3xl font-bold text-slate-900 mb-6">Our Vision</h3>
              <p className="text-slate-600 leading-8">
                To become the premier trusted global engineering service engineering , setting advanced industry standards in Building Information Modeling (BIM) lifecycle coordination and optimized structural rebar execution frameworks.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
            {[
              { text: "100+", sub: "Projects Completed", desc: "Residential • Commercial • Infrastructure" },
              { text: "Engineering", sub: "Falcosys & Astra", desc: "Pooled Specialized Expertise" },
              { text: "Global", sub: "GCC & Worldwide", desc: "Comprehensive Coverage" },
              { text: "Optimized", sub: "Bar Bending Schedules", desc: "Minimized Steel Scrap" }
            ].map((stat, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-md border border-slate-200 p-6 text-center hover:shadow-xl transition">
                <h2 className="text-5xl font-black text-[#C8A96B]">{stat.text}</h2>
                <p className="mt-3 font-semibold text-slate-900">{stat.sub}</p>
                <p className="text-sm text-slate-500 mt-2">{stat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* COMPREHENSIVE ENGINEERING SERVICES */}
      <section className="bg-white py-16 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <p className="uppercase tracking-[5px] text-[#C8A96B] font-semibold">Our Expertise</p>
            <h2 className="text-5xl font-bold text-slate-900 mt-4">Core Engineering Specializations</h2>
            <p className="text-slate-600 text-lg mt-6 leading-8">
              Through advanced technology, industry expertise, and a commitment to precision, we help clients enhance constructability and achieve flawless building performance.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { title: "Structural Rebar Detailing", desc: "Producing precise reinforcement detailing that meets project specifications and industry standards perfectly." },
              { title: "Bar Bending Schedules (BBS)", desc: "Developing accurate and optimized schedules that minimize steel wastage, reduce costs, and accelerate on-site placement." },
              { title: "Shop Drawings", desc: "Generating clear, code-compliant fabrication and construction drawings that facilitate seamless project execution." },
              { title: "MEP BIM Coordination", desc: "Creating fully coordinated Building Information Models (BIM) that integrate Mechanical, Electrical, and Plumbing systems with structural components." },
              { title: "Clash Detection", desc: "Advanced spatial multi-disciplinary clash management to isolate structural anomalies before physical setup." },
              { title: "Engineering Solutions", desc: "Reliable, innovative, and efficient engineering solutions contributing to successful project execution across residential, commercial, industrial, and infrastructure sectors." }
            ].map((service, index) => (
              <div key={index} className="group bg-slate-50 border border-slate-200 rounded-2xl p-6 hover:shadow-xl hover:-translate-y-2 transition duration-300">
                <div className="w-16 h-16 rounded-2xl bg-[#0F172A] text-white flex items-center justify-center text-2xl font-bold mb-6 group-hover:bg-[#C8A96B] group-hover:text-slate-900 transition">
                  {String(index + 1).padStart(2, "0")}
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">{service.title}</h3>
                <p className="text-slate-600 leading-8">{service.desc}</p>
              </div>
            ))}
          </div>
          {/* INTENSE BIM SERVICES DISPLAY */}
          <div className="mt-20 bg-slate-900 rounded-3xl overflow-hidden shadow-2xl">
            <div className="grid lg:grid-cols-2">
              <div className="p-14 justify-center flex flex-col">
                <p className="uppercase tracking-[5px] text-[#C8A96B] font-semibold">BIM SERVICES</p>
                <h2 className="text-5xl font-bold text-white mt-5">Building Information Modeling</h2>
                <p className="text-slate-300 leading-8 mt-8">
                  We bridge the gap between design and construction by delivering coordinated, clash-free models and detailed engineering documentation using data inputs from across our Engineering frameworks.
                </p>
                <div className="grid sm:grid-cols-2 gap-5 mt-8">
                  {[
                    "Structural BIM", "MEP Coordination", "Clash-Free Models", 
                    "Clash Detection", "Shop Drawing Extraction", "Architectural Integration", 
                    "Constructability Optimization", "Engineering Consultation"
                  ].map((item, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <FaCheckCircle className="text-[#C8A96B] flex-shrink-0" />
                      <span className="text-slate-200">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="h-[360px] lg:h-auto">
                <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab" alt="Intelligent BIM Development" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* INDUSTRIES WE SERVE */}
      <section className="bg-slate-50 py-16 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="uppercase tracking-[5px] text-[#C8A96B] font-semibold">Industries</p>
            <h2 className="text-5xl font-bold text-slate-900 mt-4">Industries We Serve</h2>
            <p className="text-slate-600 text-lg mt-6 max-w-3xl mx-auto">
              Our multidisciplinary engineering  expertise supports structures across diverse sectors throughout the GCC and international markets.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              "Residential Sector", "Commercial Towers", "Industrial Facilities", 
              "Infrastructure Projects", "Educational Institutions", "Healthcare Facilities", 
              "Hospitality Projects", "Government Projects"
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 border border-slate-200 text-center hover:shadow-xl hover:-translate-y-2 transition">
                <FaBuilding className="text-5xl text-[#C8A96B] mx-auto mb-6" />
                <h3 className="text-xl font-bold text-slate-900">{item}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ENGINEERING ASSOCIATES SYNDICATE */}
      <section className="bg-white py-16 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="uppercase tracking-[5px] text-[#C8A96B] font-semibold">Our Associates</p>
            <h2 className="text-5xl font-bold text-slate-900 mt-4">The Engineering</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-slate-50 rounded-3xl border border-slate-200 p-6 text-center hover:shadow-xl transition">
              <h3 className="text-2xl font-bold text-slate-900">VAMCO LLC</h3>
              <p className="text-slate-600 mt-4 leading-7">
                Vamco Architectural Prospective Drawings Services LLC provides core high-precision reinforcement structures, detailed documentation, and model supervision.
              </p>
            </div>
            <div className="bg-slate-50 rounded-3xl border border-slate-200 p-6 text-center hover:shadow-xl transition">
              <h3 className="text-2xl font-bold text-slate-900">Falcosys Infotech Ltd</h3>
              <p className="text-slate-600 mt-4 leading-7">
                Providing technical foundation expertise, detailing computation systems, and collaborative development lifecycle support.
              </p>
            </div>
            <div className="bg-slate-50 rounded-3xl border border-slate-200 p-6 text-center hover:shadow-xl transition">
              <h3 className="text-2xl font-bold text-slate-900">Astra Engineering Consultants</h3>
              <p className="text-slate-600 mt-4 leading-7">
                Delivering advanced global design benchmarks, input frameworks, and comprehensive engineering structural analytics.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* REGIONAL COVERAGE MAP TRANSITION */}
      <section className="bg-slate-900 py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="uppercase tracking-[5px] text-[#C8A96B]">Global Presence</p>
            <h2 className="text-5xl font-bold text-white mt-4">Coverage GCC & Globally</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              "United Arab Emirates", "Saudi Arabia", "Qatar", "Oman",
              "Kuwait", "Bahrain", "Global Remote Projects", "International Markets"
            ].map((country, index) => (
              <div key={index} className="bg-white/5 rounded-2xl border border-white/10 p-6 text-center hover:bg-white/10 transition">
                <FaGlobe className="text-[#C8A96B] text-4xl mx-auto mb-5" />
                <p className="text-white font-semibold">{country}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CLIENT TESTIMONIALS */}
      <section className="bg-white py-16 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="uppercase tracking-[5px] text-[#C8A96B] font-semibold">Client Testimonials</p>
            <h2 className="text-5xl font-bold text-slate-900 mt-4">Trusted By Engineering Professionals</h2>
          </div>
          <div className="grid lg:grid-cols-3 gap-6">
            {[
              { company: "Leading GCC Contractor", quote: "VAMCO delivered exceptional rebar detailing with remarkable accuracy. Their BIM coordination significantly reduced steel scrap variations." },
              { company: "Structural Consultant", quote: "Highly professional engineering team. Their shop drawings and optimized BBS speed up structural site placement." },
              { company: "International Developer", quote: "Excellent coordination, fast turnaround and technically sound engineering documentation. Coordinated clash-free layout designs." }
            ].map((item, index) => (
              <div key={index} className="bg-slate-50 rounded-3xl border border-slate-200 p-6 hover:shadow-xl transition">
                <FaQuoteLeft className="text-[#C8A96B] text-4xl mb-6" />
                <p className="text-slate-600 leading-8 italic">"{item.quote}"</p>
                <div className="flex mt-8 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} className="text-[#C8A96B] mr-1" />
                  ))}
                </div>
                <h3 className="font-bold text-slate-900">{item.company}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* LEADERSHIP TEAM SECTION */}
      <section className="bg-slate-50 py-16 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="uppercase tracking-[5px] text-[#C8A96B] font-semibold">Leadership</p>
            <h2 className="text-5xl font-bold text-slate-900 mt-4">Our Engineering Leaders</h2>
            <p className="text-slate-600 text-lg mt-6 max-w-2xl mx-auto">
              Meet the industry experts driving multi-disciplinary precision, material optimization, and structural synchronization across global construction markets.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {[
              { name: "Varun Pillai", role: "Executive Director", company: "Management & Operations", email: "info@vamcouae.com" },
              { name: "Mahesh", role: "Technical Director", company: "Engineering & Detailing", email: "support@astraengineering.com" },
              { name: "Ayyadurai R", role: "Chief Finance Officer", company: "Finance & Administration", email: "ayyadurai.r@falcosys.in" }
            ].map((member, index) => (
              <div key={index} className="bg-white rounded-3xl p-6 border border-slate-200 text-center shadow-sm hover:shadow-xl hover:-translate-y-1 transition duration-300 flex flex-col justify-between">
                <div>
                  <div className="w-24 h-24 rounded-full bg-slate-900 text-[#C8A96B] mx-auto mb-6 flex items-center justify-center text-3xl font-black border-4 border-white shadow-md">
                    {member.name.split(" ").map(n => n[0]).join("")}
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900">{member.name}</h3>
                  <p className="text-[#C8A96B] font-semibold text-sm uppercase tracking-wider mt-1">{member.role}</p>
                  <p className="text-slate-400 text-xs mt-0.5 font-medium">{member.company}</p>
                </div>
                <div className="mt-8 pt-4 border-t border-slate-100 flex items-center justify-center gap-4 text-slate-500">
                  <a href={`mailto:${member.email}`} className="p-2 rounded-xl bg-slate-50 hover:bg-[#C8A96B]/10 hover:text-[#C8A96B] transition" title="Email Operator">
                    <FaEnvelope />
                  </a>

               
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL GLOBAL FOOTER BANNER */}
      <section className="bg-slate-950 py-14">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white">Engineering Excellence Beyond Boundaries</h2>
          <div className="flex flex-wrap justify-center gap-4 mt-8">
            <span className="bg-white/10 text-white px-5 py-3 rounded-full text-sm font-medium">100+ Projects Completed</span>
            <span className="bg-white/10 text-white px-5 py-3 rounded-full text-sm font-medium">Coverage GCC & Globally</span>
            <span className="bg-white/10 text-white px-5 py-3 rounded-full text-sm font-medium">Falcosys & Astra Engineering</span>
            <span className="bg-white/10 text-white px-5 py-3 rounded-full text-sm font-medium">MEP BIM Coordination</span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;